interface StudioBuildEnv {
  DEV: boolean
  VITE_WORKFLOW_STUDIO?: string
}

/**
 * Whether this build ships the Workflow Studio (UC-077): always in local
 * development, and in a build whose env file sets `VITE_WORKFLOW_STUDIO=true`
 * (`.env.qa` and `.env.production` do). Without it, New / Edit keep
 * opening the name-only modals. Both the routes and the buttons read this one
 * switch, so a button never points to a route the build does not have.
 */
export function isWorkflowStudioEnabled(env: StudioBuildEnv = import.meta.env): boolean {
  return env.DEV || env.VITE_WORKFLOW_STUDIO === 'true'
}
